// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"336b81ac","732":"acef036a","977":"25259e73"}[chunkId] + ".chunk.js";
};